export const Analytics = {
  source: 'collectionScreen',
  subjectId: {
    screenRendered: 'collectionScreenRendered',
    appTilesRendered: 'collectionAppTilesRendered',
    appTileClicked: 'collectionAppTileClicked',
    loadMoreClicked: 'collectionLoadMoreClicked',
    sortOptionSelected: 'collectionSortOptionSelected',
    openCollectionSortSelector: 'openCollectionSortSelector',
  },
  event: {
    globalError: 'global',
    initialError: 'initial',
    loadMoreError: 'load more',
  },
};
